import { gql } from "@apollo/client";

import { AskAiChatMessageFragment } from "./get-ask-ai-session-query";

export default gql`
  ${AskAiChatMessageFragment}
  mutation retryAskAiMessageMutation($chatSessionId: Int) {
    retryChatbotSession(chatSessionId: $chatSessionId) {
      chatSession {
        id
        updated
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
